export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["के लिए विजेट निर्माण"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रद्द करें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खाता"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जेनरेट करें"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["में भुगतान"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["भुगतान की राशि"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सफलता पर क्रियाएँ"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["असफलता पर क्रियाएँ"])}
}